import {getPageModal, getPreviousPage, getnextPage, removePageModal, setPageModal} from "@/helpers/Helpers";

export default {
    data () {
        return {
            search: '',
            params: {
                sortBy: '', //Field key for sorting by (or null for no sorting
                sortOrder: false, // true if sorting descending, false otherwise
                search:'',
                page : 1,
            },
        }
    },
    methods: {
        async preservePagination( page_attribute, search_attribute, routeName, listingCallFn){
                const product_modal = getPageModal();
                if(product_modal && product_modal.page && product_modal.page_name === routeName){
                    let params = `?${page_attribute}=${product_modal.page}`;
                    if(product_modal.search) {
                        this.search = product_modal.search
                        if(Object.prototype.hasOwnProperty.call(this.search, "search")){
                            let url_params = new URLSearchParams(this.search);
                            params = '?'+url_params.toString();
                        }else{
                            params += `&${search_attribute}=${product_modal.search}`;
                        }
                    }
                    await listingCallFn(params);
                }
                else{
                    removePageModal()
                    await listingCallFn('')
                }
            },
        async preservePaginationIgnoreSearch( page_attribute, search_attribute, routeName, listingCallFn){
            const product_modal = getPageModal();
            if(product_modal && product_modal.page && product_modal.page_name === routeName){
                let params = `?${page_attribute}=${product_modal.page}`;
                if(product_modal.search) {
                    this.search = product_modal.search
                    if(Object.prototype.hasOwnProperty.call(this.search, "search")){
                        if(this.search.search){
                            this.params.search = '';
                            let url_params = new URLSearchParams(this.params);
                            params = '?'+url_params.toString();
                            setPageModal(1,routeName,this.params);
                            await listingCallFn('');
                        }
                        else{
                            this.params.page = product_modal.page;
                            let url_params = new URLSearchParams(this.params);
                            params = '?'+url_params.toString();
                            setPageModal(product_modal.page,routeName,this.params);
                            await listingCallFn(params);
                        }

                    }else{
                        this.search = '';
                        setPageModal(1,routeName,this.search);
                        await listingCallFn('');
                    }
                }else{
                    let params = `?${page_attribute}=${product_modal.page}`;
                    await listingCallFn(params);
                }

            }
            else{
                removePageModal()
                await listingCallFn('')
            }
        },
        async previousPageOnDeletion( page_attribute, search_attribute, array_length, routeName, listingCallFn){
            if(array_length == 0){
                let previous_page = getPreviousPage();
                if(previous_page){
                    let params = `?${page_attribute}=${previous_page}`;
                    const product_modal = getPageModal();
                    if(product_modal && product_modal.page && product_modal.page_name === routeName){
                        this.search = product_modal.search;
                        if(this.search) {
                            if(Object.prototype.hasOwnProperty.call(this.search, "search")){
                                this.params.page = previous_page;
                                setPageModal(previous_page,routeName,this.params);
                                let url_params = new URLSearchParams(this.params);
                                params = '?'+url_params.toString();
                                this.search = '';
                            }else{
                                params += `&${search_attribute}=${this.search}`;
                                setPageModal(previous_page,routeName,this.search);
                            }
                        }
                        else{
                            setPageModal(previous_page,routeName,this.search);
                        }
                    }
                    await listingCallFn(params);
                }
            }
            else{
                this.preservePagination( page_attribute, search_attribute, routeName, listingCallFn)
            }
        },
        async nextPageOnCreation( page_attribute, search_attribute, array_length, per_page, current_page, last_page, routeName, listingCallFn){
            if((array_length >= per_page) && current_page <= last_page){
                    let next_page = last_page;
                    let params = `?${page_attribute}=${next_page}`;
                    const product_modal = getPageModal();
                    if(product_modal && product_modal.page && product_modal.page_name === routeName) {
                        this.search = product_modal.search;
                        if (this.search) {
                            if (Object.prototype.hasOwnProperty.call(this.search, "search")) {
                                this.params.page = next_page;
                                setPageModal(next_page, routeName, this.params);
                                let url_params = new URLSearchParams(this.params);
                                params = '?' + url_params.toString();
                                this.search = '';
                            } else {
                                params += `&${search_attribute}=${this.search}`;
                                setPageModal(next_page, routeName, this.search);
                            }
                        }
                        await listingCallFn(params);
                    }
            }
            else{
                this.preservePagination( page_attribute, search_attribute, routeName, listingCallFn)
            }
        }
    }
}